import { render } from "./LoginPage.vue?vue&type=template&id=c8f44302&scoped=true"
import script from "./LoginPage.vue?vue&type=script&lang=js"
export * from "./LoginPage.vue?vue&type=script&lang=js"

import "./LoginPage.vue?vue&type=style&index=0&id=c8f44302&scoped=true&lang=css"

import exportComponent from "C:\\Users\\Melissa\\Desktop\\lifehack\\lifehack\\lifehack\\node_modules\\vue-loader\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-c8f44302"]])

export default __exports__